/* Brokerage tour builder — thin wrapper over the shared RouteBuilderDialog.
 * Identical optimization + UX to the Open House RouteDialog by construction
 * (hooks/useRouteOptimizer + lib/routeOptimizer). */
import React, { useMemo } from "react";
import api from "@/lib/api";
import { shortAddress } from "@/lib/address";
import RouteBuilderDialog from "@/components/route/RouteBuilderDialog";

export default function BrokerageRouteDialog({
  open,
  onClose,
  selectedIds,
  brokerages,
  onReorder,
  onRemoveStop,
  optimizationState,
  onApplyOptimized,
  homeCoords,
  onOpenDetail, // (brokerage) => void — opens the Brokerage Details pane
}) {
  const byId = useMemo(() => new Map((brokerages || []).map((b) => [b.id, b])), [brokerages]);
  const stops = useMemo(() => {
    return (selectedIds || [])
      .map((id) => byId.get(id))
      .filter(Boolean)
      .map((b) => ({
        id: b.id,
        lat: b.lat,
        lng: b.lng,
        title: b.name,
        subtitle: shortAddress(b.office_address) || "No address on file",
      }));
  }, [byId, selectedIds]);

  return (
    <RouteBuilderDialog
      open={open}
      onClose={onClose}
      stops={stops}
      onReorder={onReorder}
      onRemoveStop={onRemoveStop}
      onStopClick={onOpenDetail ? (id) => byId.get(id) && onOpenDetail(byId.get(id)) : undefined}
      optimizationState={optimizationState}
      onApplyOptimized={onApplyOptimized}
      homeCoords={homeCoords}
      title="Build brokerage tour"
      unitLabel="office"
      testIdPrefix="brokerage-route"
      page="brokerages"
      buildRequest={async (start_address, travel_mode) => {
        const { data } = await api.post("/brokerages/route", {
          brokerage_ids: selectedIds,
          start_address,
          travel_mode,
        });
        return data;
      }}
    />
  );
}
